module.exports = __webpack_public_path__ + "img/GIF.e857bc26.svg";